import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("../views/Profile.vue"),
  },
  {
    path: "/date",
    name: "Date",
    component: () => import("../views/Date.vue"),
  },
  {
    path: "/user_info",
    name: "UserInfo",
    component: () => import("../views/UserInfo.vue"),
    props: { identifier: { type: String, default: "" } },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: () => import("../views/Notifications.vue"),
  },
  {
    path: "/account_settings",
    name: "AccountSettings",
    component: () => import("../views/AccountSettings.vue"),
  },
  {
    path: "/invitation_response",
    name: "InvitationResponse",
    component: () => import("../views/InvitationResponse.vue"),
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue"),
  },
  {
    path: "/edit_pet",
    name: "EditPet",
    component: () => import("../views/EditPet.vue"),
  },
  {
    path: "/add_pet",
    name: "AddPet",
    component: () => import("../views/AddPet.vue"),
  },
  {
    path: "/under_construction",
    name: "UnderConstruction",
    component: () => import("../views/UnderConstruction.vue"),
  },
  {
    path: "/external_auth",
    name: "ExternalAuth",
    component: () => import("../views/ExternalAuth.vue"),
  },
  {
    path: "/add_business",
    name: "AddBusiness",
    component: () => import("../views/AddBusiness.vue"),
  },
  {
    path: "/edit_business",
    name: "EditBusiness",
    component: () => import("../views/EditBusiness.vue"),
  },
  {
    path: "/businesses",
    name: "Businesses",
    component: () => import("../views/Businesses.vue"),
  },
  {
    path: "/business_info",
    name: "BusinessInfo",
    component: () => import("../views/BusinessInfo.vue"),
  },
  {
    path: "/alert",
    name: "Alert",
    component: () => import("../views/Alert.vue"),
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
